<template>
  <nav
    :class="
      appName === 'ANSI'
        ? 'navbar is-info is-fixed-top'
        : 'navbar is-light is-fixed-top'
    "
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <router-link to="/" class="navbar-item">
        <img src="../../assets/ansi-logo.png" v-if="appName === 'ANSI'" />
        <img src="../../assets/adaptive-logo.png" v-else />
        {{ appName }}
      </router-link>

      <a
        role="button"
        class="navbar-burger burger"
        aria-label="menu"
        aria-expanded="false"
        onclick="document.querySelector('.navbar-menu').classList.toggle('is-active');"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div class="navbar-menu">
      <div class="navbar-start"></div>

      <div
        class="navbar-end"
        onclick="document.querySelector('.navbar-menu').classList.toggle('is-active');"
      >
        <router-link
          to="/"
          class="navbar-item text-size"
          v-show="
            (!hasTechnicalPrivOnly &&
              !hasAdminSalesOrDeliveryPriv &&
              !hasAdminSalesOrSalesAccountingStaffPriv) ||
              hasAdminSales
          "
          >Dashboard</router-link
        >
        <router-link
          :to="{ name: 'List of Clients' }"
          class="navbar-item text-size"
          v-show="
            (!hasTechnicalPrivOnly &&
              !hasAdminSalesOrDeliveryPriv &&
              !hasAdminSalesOrSalesAccountingStaffPriv) ||
              hasAdminSales
          "
          >Clients</router-link
        >
        <router-link
          :to="{ name: 'List of Suppliers' }"
          class="navbar-item text-size"
          v-show="
            (!hasTechnicalPrivOnly &&
              !hasAdminSalesOrDeliveryPriv &&
              !hasAdminSalesOrSalesAccountingStaffPriv) ||
              hasAdminSales
          "
          >Suppliers</router-link
        >
        <div
          class="navbar-item text-size has-dropdown is-hoverable"
          v-show="
            (!hasTechnicalPrivOnly &&
              !hasAdminSalesOrDeliveryPriv &&
              !hasAdminSalesOrSalesAccountingStaffPriv) ||
              hasAdminSales
          "
        >
          <a class="navbar-link"> Sales Quote </a>

          <div class="navbar-dropdown">
            <router-link
              :to="{ name: 'List of Sales Quote', params: { pageSize: 10 } }"
              class="navbar-item text-size"
              >View all</router-link
            >
            <router-link
              :to="{ name: 'Create Sales Quote' }"
              class="navbar-item text-size"
              >Create new</router-link
            >
          </div>
        </div>
        <div
          class="navbar-item text-size has-dropdown is-hoverable"
          v-show="
            (!hasTechnicalPrivOnly &&
              !hasAdminSalesOrDeliveryPriv &&
              !hasAdminSalesOrSalesAccountingStaffPriv) ||
              hasAdminSales
          "
        >
          <a class="navbar-link"> P.O. request </a>

          <div class="navbar-dropdown">
            <router-link
              :to="{
                name: 'List of PO Requests',
                params: { byStatus: 'all', pageSize: 10 }
              }"
              class="navbar-item text-size"
              >View all</router-link
            >
            <router-link
              :to="{ name: 'Create PO Request' }"
              class="navbar-item text-size"
              >Create new</router-link
            >
          </div>
        </div>
        <router-link
          v-if="hasAdminPriv"
          :to="{
            name: 'List of PO Requests for Final Approval',
            params: { byStatus: 'all', pageSize: 10 }
          }"
          class="navbar-item text-size"
          >My Approvals (P.O Request)&nbsp;
          <span class="tag is-warning" v-if="totalPoRequestForFinalApproval">
            <span v-if="isFetchingTotalPoRequestForFinalApproval">...</span>
            <span v-else>
              {{ totalPoRequestForFinalApproval }}
            </span>
          </span>
        </router-link>
        <div
          class="navbar-item text-size has-dropdown is-hoverable"
          v-show="
            hasAdminSalesOrSalesPoStaffPriv ||
              hasAdminSalesOrSalesAccountingStaffPriv
          "
        >
          <a class="navbar-link"> Purchase Order </a>

          <div class="navbar-dropdown">
            <router-link
              :to="{
                name: 'List of Purchase Order',
                params: {
                  page: 1
                }
              }"
              class="navbar-item text-size"
              >View all</router-link
            >
            <router-link
              v-show="hasAdminSalesOrSalesPoStaffPriv"
              :to="{ name: 'Create New Purchase Order' }"
              class="navbar-item text-size"
              >Create new</router-link
            >
          </div>
        </div>
        <router-link
          v-show="hasAdminSalesOrSalesAccountingStaffPriv"
          :to="{
            name: 'List of Purchase Order To Receive',
            params: {
              pageSize: 10
            }
          }"
          class="navbar-item text-size"
          >Receiving</router-link
        >
        <router-link
          :to="{ name: 'List of Delivery' }"
          class="navbar-item text-size"
          v-show="hasAdminSalesOrDeliveryPriv"
          >Delivery</router-link
        >
        <router-link
          :to="{ name: 'List of Billing' }"
          class="navbar-item text-size"
          v-show="hasAdminSalesOrDeliveryPriv"
          >Billing</router-link
        >
        <router-link
          :to="{ name: 'Report' }"
          class="navbar-item text-size"
          v-show="hasAdminSales"
          >Report</router-link
        >
        <div class="navbar-item text-size has-dropdown is-hoverable">
          <a class="navbar-link"> Misc </a>

          <div class="navbar-dropdown">
            <router-link
              v-show="!hasAdminSalesOrDeliveryPriv || hasAdminSales"
              :to="{
                name: 'List of Ticketing for Item',
                params: {
                  page: 1,
                  pageSize: 10,
                  sow: 'all',
                  itemType: 'all',
                  progressStat: 'all'
                }
              }"
              class="navbar-item text-size"
              >Ticketing for Item</router-link
            >
            <router-link
              :to="{ name: 'List of Product/Service', params: { pageSize: 1 } }"
              class="navbar-item text-size"
              v-show="hasAdminSalesOrSalesPoStaffPriv"
              >Products/Services</router-link
            >
            <router-link
              v-show="hasAdminSalesAndPullOut"
              :to="{ name: 'List of Pull Out to Client' }"
              class="navbar-item text-size"
              >Pull out</router-link
            >
          </div>
        </div>
        <router-link
          :to="{ name: 'List of Users' }"
          class="navbar-item text-size"
          v-show="hasAdminPriv"
          >User management</router-link
        >
        <div class="navbar-item text-size">
          <div class="buttons">
            <a
              class="button is-light"
              @click="logoutUser"
              style="font-size: 14px"
            >
              Log out
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<style>
.text-size {
  font-size: 12px;
}
</style>

<script>
import AuthService from "../../_services/auth";
import _ from "lodash";
import axios from "axios";
import { mapState, mapActions } from "vuex";

const authService = new AuthService();

export default {
  data() {
    return {
      appName: process.env.VUE_APP_ANOTHER_VARIABLE,
      hasAdminPriv: authService.hasAdminPriv(),
      hasAdminSalesAndPullOut: authService.hasAdminSalesOrSalesPullOutPriv(),
      hasAdminSales: authService.hasAdminSalesAndMainAdminPriv(),
      hasTechnicalPrivOnly: authService.hasTechnicalPrivOnly(),
      hasAdminSalesOrDeliveryPriv: authService.hasAdminSalesOrDeliveryPriv(),
      hasAdminSalesOrSalesPoStaffPriv: authService.hasAdminSalesOrSalesPoStaffPriv(),

      hasAdminSalesOrSalesAccountingStaffPriv: authService.hasAdminSalesOrSalesAccountingStaffPriv()
    };
  },
  computed: {
    ...mapState("misc", {
      totalPoRequestForFinalApproval: state =>
        state.totalPoRequestForFinalApproval,
      isFetchingTotalPoRequestForFinalApproval: state =>
        state.isFetchingTotalPoRequestForFinalApproval
    })
  },
  created() {
    this.getTotalPoRequestForFinalApproval();
  },
  methods: {
    ...mapActions("misc", ["getTotalPoRequestForFinalApproval"]),
    logoutUser() {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");

      // revoke refresh token
      axios
        .post(`api/token/revoke`)
        .then(response => {
          console.log(response.data);
        })
        .catch(error => console.log(error));

      this.$router.go("/login");
    }
  }
};
</script>
